import * as React from "react";
function SvgDownload(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3 19a2 2 0 002 2h14a2 2 0 002-2v-3h-2v3H5v-3H3v3zm8.293-2.293l-5-5 1.414-1.414L11 13.586V3h2v10.586l3.293-3.293 1.414 1.414-5 5a1 1 0 01-1.414 0z"
                fill="currentcolor"
            />
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgDownload);
export default ForwardRef;
